<script>
  import tiposConta from '~js/tipos-conta';
  
  export default {
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
      dadosBancarios: {
        type: Array,
        required: true,
      }
    },
    data() {
      return {
        tiposConta: tiposConta
      }
    },
    methods: {
      validar(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        return this.$validator.validateAll();
      },
      nomeTipoConta(tipo) {
        tipo = tipo !== -1 ? tipo : -1;
        if (tipo == -1) {
          return "---";
        } else {
          return this.tiposConta.find(tipoConta => {
            return tipoConta.id === tipo;
          }).nome;
        }
      },
      selecionar(dadoBancario) {
        this.solicitacao.banco = dadoBancario.numeroBanco;
        this.solicitacao.agencia = dadoBancario.numeroAgencia;
        this.solicitacao.contaCorrente = dadoBancario.numeroConta;
        this.solicitacao.tipoConta = dadoBancario.tipoConta;
      },
      contaSelecionada(dadoBancario) {
        return dadoBancario.numeroBanco == this.solicitacao.banco &&
          dadoBancario.numeroAgencia == this.solicitacao.agencia &&
          dadoBancario.contaCorrente == this.solicitacao.numeroConta &&
          dadoBancario.tipoConta == this.solicitacao.tipoConta;
      }
    }
  }
</script>

<template>
  <div>
    
    <div class="table-responsive">
      <table class="table table-hover table-pointer table-column-code">
        <thead>
          <tr>
            <th></th>
            <th>Banco</th>
            <th>Agência</th>
            <th>Número da conta</th>
            <th>Tipo de conta</th>
            <th>Conta padrão</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="dadoBancario in dadosBancarios" @click="selecionar(dadoBancario)">
            <td>
              <i class="fa fa-check text-primary" v-show="contaSelecionada(dadoBancario)"></i>
            </td>
            <td>{{ dadoBancario.numeroBanco }}</td>
            <td>{{ dadoBancario.numeroAgencia }}</td>
            <td>{{ dadoBancario.numeroConta }}</td>
            <td>{{ nomeTipoConta(dadoBancario.tipoConta) }}</td>
            <td>{{ dadoBancario.contaPadrao ? 'Sim' : 'Não' }}</td>
          </tr>
          <tr v-if="dadosBancarios.length === 0">
            <td colspan="6" class="text-center">Nenhum registro encontrado.</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="6"><small>Clique sobre o dado bancário para seleciona-lo.</small></td>
          </tr>
        </tfoot>
      </table>
    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-faturamento-multiservicos/componentes/compartilhado/FormDadosBancarios.vue